export default __webpack_public_path__ + "static/media/kitchen4-afterC-480w.e7839683.avif";